<template>
  <div class="welcomeScreen">
    <div class="show-first"></div>
    <div class="show-second"><h1 class="loading-h1">MEBLE</h1></div>
    <div class="show-third"><h1 class="loading-h1">AGMAR</h1></div>
  </div>
</template>

<script>
import { TweenMax, Expo } from 'gsap';
import { mapState } from 'vuex';
export default {
    name: 'welcomeScreen',
    computed:{
        ...mapState({
            carouselImages: state=>state.carousel.carouselImages,
        })
    },
    mounted(){
        TweenMax.to(".show-first", 2, {
            delay: 1,
            top: "-110%",
            ease: Expo.easeInOut
        });

        TweenMax.to(".show-second", 2, {
            delay: 2,
            top: "-110%",
            ease: Expo.easeInOut
        });
        TweenMax.to(".show-third", 2, {
            delay: 3,
            top: "-110%",
            ease: Expo.easeInOut
        });
        }
    }
</script>

<style scoped lang="scss">
$first-loader-color: #55BCC9;
$second-loader-color: #45A29E;
$third-loader-color: #1F2833;
.loading{
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    background: $third-loader-color;
    color: $first-loader-color;
    display: flex;
    justify-content: center;
    align-items: center;
}
.welcomeScreen{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
}
.show-first{
    position: fixed;
    background: $first-loader-color;
    z-index: 8000;
    top: 0;
    width: 100%;
    height: 100%;
}
.show-second{
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $second-loader-color;
    z-index: 7000;
    top: 0;
    width: 100%;
    height: 100%;
}
.show-third{
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $third-loader-color;
    z-index: 6000;
    top: 0;
    width: 100%;
    height: 100%;
}
.loading-h1{
    color: white;
    font-size: 72px;
}
@media (min-width: 900px){
    .loading-h1{
        font-size: 10em;
    }
}
@media (min-width: 1440px){
.loading-h1{
    color: white;
    font-size: 15em;
}
}
</style>